import { render } from "./MetadataVariableDescription.vue?vue&type=template&id=3e7b5c9c"
import script from "./MetadataVariableDescription.vue?vue&type=script&lang=js"
export * from "./MetadataVariableDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__